var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 99.11 98.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2f333d;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M99.1,11.9c.21,5.23-2.51,8.38-5.55,11.27-7.45,7.09-15,14.09-22.46,21.14-4.36,4.11-4.33,5.07-.13,9.1C78.87,61,86.86,68.48,94.58,76.24c5.78,5.82,5.91,13.37.78,18.67-4.79,5-13.15,4.82-18.81-.71Q64.76,82.71,53.47,70.71c-2.64-2.81-3.95-3.7-7.09-.23-7.59,8.37-15.75,16.22-23.77,24.2-4.82,4.79-13.93,4.73-18.54,0-5.21-5.28-5.26-13,.6-18.07,8.71-7.48,16.45-15.92,24.76-23.78,2.84-2.69,3-4.55.05-7.26C21.55,38.33,14.62,30,6.19,23.2,2.59,20.3-.71,16.7.13,11.34.87,6.66,2.87,2.81,7.73,1.17,13.31-.71,18.46-.54,22.89,4c8,8.24,16.2,16.26,24.06,24.62,2.34,2.49,3.57,2.24,5.72,0,6.88-7.22,14-14.26,21-21.37C76.9,3.93,80,.59,85.19.08,93.22-.71,99.13,4.41,99.1,11.9Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconX);
export default __webpack_public_path__ + "static/media/IconX.1b9a575efcaf22a0fe677ea814ce6724.svg";
export { ForwardRef as ReactComponent };